import { PDFDocument, rgb } from 'pdf-lib';

export const convertImageToPdf = async (imageFile) => {
  const pdfDoc = await PDFDocument.create();

  const embedFromBuffer = async (mime, buffer) => {
    if (mime === 'image/jpeg' || mime === 'image/jpg') {
      return pdfDoc.embedJpg(buffer);
    }
    if (mime === 'image/png') {
      return pdfDoc.embedPng(buffer);
    }
    return null;
  };

  // First try embedding directly based on MIME
  let img = null;
  try {
    const direct = await embedFromBuffer(imageFile.type, await imageFile.arrayBuffer());
    if (direct) {
      img = direct;
    }
  } catch {}

  // Fallback: rasterize to canvas and embed as PNG
  if (!img) {
    const objectUrl = URL.createObjectURL(imageFile);
    try {
      let bitmap;
      try {
        // createImageBitmap is fast when available
        bitmap = await createImageBitmap(imageFile);
      } catch {
        bitmap = null;
      }

      let width, height, blob;
      if (bitmap) {
        const canvas = document.createElement('canvas');
        width = canvas.width = bitmap.width;
        height = canvas.height = bitmap.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(bitmap, 0, 0);
        blob = await new Promise((resolve, reject) => canvas.toBlob(b => b ? resolve(b) : reject(new Error('Canvas toBlob failed')), 'image/png'));
      } else {
        const imgEl = await new Promise((resolve, reject) => {
          const el = new Image();
          el.onload = () => resolve(el);
          el.onerror = reject;
          el.src = objectUrl;
        });
        const canvas = document.createElement('canvas');
        width = canvas.width = imgEl.naturalWidth;
        height = canvas.height = imgEl.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(imgEl, 0, 0);
        blob = await new Promise((resolve, reject) => canvas.toBlob(b => b ? resolve(b) : reject(new Error('Canvas toBlob failed')), 'image/png'));
      }

      const buffer = await blob.arrayBuffer();
      img = await pdfDoc.embedPng(buffer);
    } finally {
      URL.revokeObjectURL(objectUrl);
    }
  }

  if (!img) {
    throw new Error('Unsupported image format');
  }

  const page = pdfDoc.addPage([img.width, img.height]);
  page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });

  const pdfBytes = await pdfDoc.save();
  const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
  const pdfFile = new File([pdfBlob], imageFile.name.replace(/\.(jpg|jpeg|png|heic|heif)$/i, '.pdf'), { type: 'application/pdf' });
  return pdfFile;
};
